import moment from 'moment';
import FeatureFlags from '../../../modules/FeatureFlags';
import { PROVIDER_REFERRAL_PROGRAM_MVP_FLAG_NAME } from '../Refer/constants';

export const shouldShowAmbassadorToolkitNotification = async () => {
  const isEligibleDate = moment.utc() < moment.utc('2020-12-18T18:00:00Z');
  const isInTest = await FeatureFlags.isEnabled(PROVIDER_REFERRAL_PROGRAM_MVP_FLAG_NAME);

  return isInTest && isEligibleDate;
};
